class TopJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const topicsSwiper = '.js-top-topics-swiper';
    new Swiper(topicsSwiper, {
      slidesPerView: 'auto',
      pagination: {
        el: '.js-top-topics-swiper__pagination',
        type: 'progressbar'
      }
    })
    const mvSwiper = '.js-mv-swiper';
    let mm = gsap.matchMedia();
    mm.add('(min-width:769px)', () => {
      new Swiper(mvSwiper, {
        loop: true,
        allowTouchMove: false,
        speed: 10000,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        },
      })
    })
    mm.add('(max-width:768px)', () => {
      new Swiper(mvSwiper, {
        loop: true,
        direction: 'vertical',
        allowTouchMove: false,
        speed: 7000,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        },
      })
    })

    const videoElement = document.getElementById('video');
    const marquee = document.querySelector('.js-marquee');

    videoElement.addEventListener('play', function() {
      marquee.classList.add('is-play');
    });

    setTimeout(() => {
      marquee.classList.add('is-play');
    }, 500);
  }
}
